import apiClient, { APIResponse } from '../client';

export interface UserProgress {
  total_time_spent: number;
  total_sessions: number;
  average_accuracy: number;
  last_session_accuracy: number;
}

export const progressService = {
  getTopicProgress: async (topicId: number): Promise<APIResponse<any>> => {
    return apiClient.get(`/api/v1/practice/topics/${topicId}/progress`);
  },

  getTopics: async (): Promise<APIResponse<any>> => {
    return apiClient.get('/api/v1/topics');
  },

  getMicrotopicProgress: async (microtopicId: number): Promise<APIResponse<any>> => {
    return apiClient.get(`/api/v1/practice/microtopics/${microtopicId}/progress`);
  },
};